import React from 'react'
import { useApi, type APIParams } from "@hooks/use-api-requests.hook"
import { useAppContext } from "@hooks/use-app-context"
import { useUrlParams } from "@hooks/use-url-params.hook"
import { convertStateToBody } from "@hooks/use-vm-model"
import { currentStepAtom } from "@store/atoms"
import { useAtom } from "jotai"


function _useSalvaBozza(){
    const tableDefaults = useUrlParams()
    const { dispatch, state } = useAppContext()
    const [activeStep] = useAtom(currentStepAtom)

    const body = convertStateToBody(state, tableDefaults,activeStep)

    const [data, postData, loadingData] = useApi({
		request: 'DbOperations/SalvaOffertaRic',
		method: 'POST',
		sleeper: true,
	})

  

return {data,postData,loadingData}

}

export {_useSalvaBozza}
